module.exports = __webpack_public_path__ + "static/img/logo.713ae1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/forecast/images/logo.png
// module id = wr0D
// module chunks = 33